/**
 * Form/action shape for the Abacus connect step.
 *
 * The customer supplies four fields in the connect modal; the service maps
 * them into the generic create envelope (`POST /api/integrations/abacus` with
 * `{ displayName, vendorInput: { serverUrl, clientId, clientSecret } }`).
 * The BE's `AbacusAuthAdapter` then runs OIDC discovery, OAuth2 token acquire
 * and a smoke test atomically before persisting the connection.
 *
 * Security note: `clientSecret` flows through the NgRx action stream and HTTP
 * call. It is encrypted at rest on the BE side via per Connection DEK. Do NOT
 * log this object or echo it back to the user.
 */
export interface IAbacusConnectBody {
    /** UI label for the connection, surfaced in the manage modal tenant list. */
    displayName: string;
    /** Customer's Abacus base URL, no trailing slash, no path. e.g. `https://abaweb.example.ch`. */
    serverUrl: string;
    /** OAuth2 Client ID created by the customer's Abacus admin. */
    clientId: string;
    /** OAuth2 Client Secret. Sensitive. */
    clientSecret: string;
}
